import { Injectable } from '@angular/core'
import { config } from '../../config/appConfig'
import { HttpService } from './http.service'
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root',
})
export class TrackingService {
    httpService: HttpService = new HttpService(config.trackingServiceUrl);

    readABook(bookId: string): Observable<string> {
        return this.httpService.post("/books/" + bookId + "/read");
    }

    completeABook(bookId: string): Observable<string> {
        return this.httpService.post("/books/" + bookId + "/completed");
    }

    readAChapter(chapterId: string): Observable<string> {
        return this.httpService.post("/chapters/" + chapterId + "/read");
    }

    completeAChapter(chapterId: string): Observable<string> {
        return this.httpService.post("/chapters/" + chapterId + "/completed");
    }

    readAPage(pageId: string, timeSpent: number): Observable<string> {
        return this.httpService.post("/pages/" + pageId + "/read" + "?timeSpent=" + timeSpent.toString());
    }
}
